import { render, staticRenderFns } from "./vendorMaterialPricing.vue?vue&type=template&id=3fc565f6&scoped=true&"
import script from "./vendorMaterialPricing.vue?vue&type=script&lang=js&"
export * from "./vendorMaterialPricing.vue?vue&type=script&lang=js&"
import style0 from "./vendorMaterialPricing.vue?vue&type=style&index=0&id=3fc565f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc565f6",
  null
  
)

export default component.exports